import { render } from "./MobilePanchanga.vue?vue&type=template&id=31757158&scoped=true"
import script from "./MobilePanchanga.vue?vue&type=script&lang=js"
export * from "./MobilePanchanga.vue?vue&type=script&lang=js"

import "./MobilePanchanga.vue?vue&type=style&index=0&id=31757158&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31757158"]])

export default __exports__